import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('zorgcampus_chatbot_widget'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
